import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { DataGrid } from "@mui/x-data-grid"
import { DataGridStyles, DataGridWrapperStyles } from "../styles/AdminStyles"
import { getAuditLog } from "../../../actions/adminActions"
import { toColumns } from "../AdminSharedFunctions"
import AuditToolBar from "./AuditToolBar"
import { Box } from "@mui/material"

export default function AuditGrid() {
    const dispatch = useDispatch()

    // Store Variables
    const admin = useSelector((state) => state.admin)
    const auth = useSelector((state) => state.auth)
    const permissions = useSelector((state) => state.auth.permissions)

    useEffect(() => {
        if (auth.authenticated) {
            async function runUseEffectFunctions() {
                await dispatch(getAuditLog())
            }
            runUseEffectFunctions()
        }
    }, [dispatch, auth])

    //creating columns and rows for the grid
    let columns = []
    let rows = []
    const auditLog = admin.auditLog
    if (auditLog.length > 0) {
        columns = toColumns(Object.keys(auditLog[0]), permissions)
        rows = auditLog
    }

    return (
        <Box sx={DataGridWrapperStyles}>
            <DataGrid
                getRowId={(row) => row.ChangeId}
                rows={rows}
                columns={columns}
                components={{ Toolbar: AuditToolBar }}
                sx={DataGridStyles}
                columnVisibilityModel={{
                    ChangeId: false
                }}
            />
        </Box>
    )
}
